import * as bootstrap from 'bootstrap';
import Helper from './helper';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.menu();

        this.cookies();

        this.asyncForms();

        this.smoothScrolling();

        this.contentBlocks();

        this.highlights();

        this.navigationBar();

        this.responsiveEmbeds();
    }

    menu() {
        // Fetch the navigation bar
        let navigation = document.getElementById('navigation-bar');

        let updateState = () => {
            // Toggle scrolled state
            document.body.classList.toggle('scrolled', window.scrollY > navigation.offsetHeight);
        }

        // Bind the scroll event listener to the window
        window.addEventListener('scroll', function () {
            updateState();
        });

        updateState();
    }

    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookie-options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            Helper.post(this.action, new FormData(this)).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    asyncForms() {
        let gRecaptchaWidgets = [];

        document.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
            let widgetId = grecaptcha.render(recaptcha.id, {
                'sitekey' : config.recaptcha_site_key
            });

            gRecaptchaWidgets.push(widgetId);
        });

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (typeof grecaptcha !== 'undefined' && grecaptcha) {
                // Refresh all recaptcha widget instances
                gRecaptchaWidgets.forEach(widgetId => {
                    grecaptcha.reset(widgetId);
                });
            }
        }

        setInterval(function() {
            refreshRecaptcha();
        }, 2 * 60 * 1000);

        document.querySelectorAll('.form-async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh reCAPTCHA
                        refreshRecaptcha();

                        formMessages.innerHTML = '<div class="alert alert-basic alert-' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh reCAPTCHA
                    refreshRecaptcha();

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    smoothScrolling() {
        document.querySelectorAll(['a[href^="#"]']).forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();

                let target = document.querySelector(this.getAttribute('href'));

                if (target === null) {
                    return;
                }

                window.scrollTo({
                    top      : target.getBoundingClientRect().top + window.scrollY,
                    behavior : 'smooth'
                });
            });
        });
    }

    contentBlocks() {
        let contentBlocks = document.querySelector('.content-blocks');

        if (contentBlocks === null) {
            return false;
        }

        let updateContentBlocks = () => {
            document.querySelectorAll('.content-blocks').forEach(container => {
                const titles = Array.from(container.querySelectorAll('h2,h3,h4,h5,h6'));

                // Reset heights first to get natural heights
                titles.forEach(title => {
                    title.style.height = 'auto';
                });

                // Get the max height
                const highestTitleHeight = titles.reduce((maxHeight, title) => {
                    const height = title.getBoundingClientRect().height;
                    return Math.max(maxHeight, height);
                }, 0);

                // Apply max height to all
                titles.forEach(title => {
                    title.style.height = `${highestTitleHeight}px`;
                });
            });
        }

        updateContentBlocks();

        window.addEventListener('resize', Helper.debounce(() => updateContentBlocks()));
    }

    highlights() {
        let highlights = document.querySelector('.highlights');

        if (highlights === null) {
            return false;
        }

        let updateHighlights = () => {
            document.querySelectorAll('.highlights').forEach(container => {
                const titles = Array.from(container.querySelectorAll('.title'));

                // Reset heights first to get natural heights
                titles.forEach(title => {
                    title.style.height = 'auto';
                });

                // Get the max height
                const highestTitleHeight = titles.reduce((maxHeight, title) => {
                    const height = title.getBoundingClientRect().height;
                    return Math.max(maxHeight, height);
                }, 0);

                // Apply max height to all
                titles.forEach(title => {
                    title.style.height = `${highestTitleHeight}px`;
                });
            });
        }

        updateHighlights();

        window.addEventListener('resize', Helper.debounce(() => updateHighlights()));
    }

    navigationBar() {
        let observeMenu = () => {
            let navigation = document.getElementById('navigation-bar');

            // Check minimum window width
            if (window.innerWidth > 992) {
                // Check if the menu is open
                if (document.body.classList.contains('menu-open')) {
                    // Remove menu open state
                    document.body.classList.remove('menu-open');

                    // Remove navbar collapse open state
                    navigation.querySelector('.navbar-collapse').classList.remove('show');
                }
            }

            // update --navigation-bar-height variable to the height of the navigation bar
            document.documentElement.style.setProperty('--navigation-bar-height', navigation.offsetHeight + 'px');
        }

        observeMenu();

        window.addEventListener('resize', Helper.debounce(function () {
            observeMenu();
        }));

        document.querySelectorAll('.collapse').forEach(collapse => {
            // Check for the navbar collapse class
            if (collapse.classList.contains('navbar-collapse')) {
                // Collapse show event listener
                collapse.addEventListener('show.bs.collapse', function () {
                    // Hide navbar open state
                    document.body.classList.add('menu-open');
                });

                // Collapse hide event listener
                collapse.addEventListener('hide.bs.collapse', function () {
                    // Hide navbar open state
                    document.body.classList.remove('menu-open');
                });
            }
        });
    }

    responsiveEmbeds() {
        let wrap = function (toWrap, wrapper) {
            wrapper = wrapper || document.createElement('div');
            toWrap.parentNode.insertBefore(wrapper, toWrap);
            return wrapper.appendChild(toWrap);
        }

        // Responsive embeds
        document.querySelectorAll('iframe:not([class])').forEach(iframe => {
            let wrapper = document.createElement('div');

            wrapper.setAttribute('class', 'ratio ratio-16x9');

            wrap(iframe, wrapper);
        });
    }
}

window.addEventListener('load', () => new App());
